import React, { Component } from 'react'
import AllProjects from '../../project/AllProjects'
import AddOrJoinButtonBar from '../../project/addAndJoin/AddOrJoinButtonBar'
import { connect } from 'react-redux'
import Loader from 'react-loader-spinner';
import CreateCompanyButton from '../../company/CreateCompanyButton';
import DashboardLock from '../../widgets/DashboardLock';

class DashboardProjects extends Component {
    render() {
        const { companyData, themeColors, userData, userDataNotification } = this.props;
        const { cardHeaderColor } = themeColors;

        // logic for outsiders to fetch projects who will have active subscription applied always if coid is -1
        let subscriptionBoughtActive = false;
        if (userData.coid !== '-1') {
            let boughtOrderId = companyData ? 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null : null;
            subscriptionBoughtActive = boughtOrderId ? companyData.boughtSubscription.applied : false
        } else {
            subscriptionBoughtActive = true;
        }

        const header = companyData !== undefined ?
            (companyData != null ? (<AddOrJoinButtonBar />) : (<CreateCompanyButton />)) :
            (<Loader
                type="TailSpin"
                color={themeColors.themeColor}
                height={20}
                width={20}
            />
            );


        return (
            <div className="container-fluid">
                <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>
                    <div className="" style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <div className="card-header" style={{ textAlign: "start", fontWeight: "bold", backgroundColor: cardHeaderColor }}>
                            <div className="">
                                {header}
                            </div>
                        </div>
                        <div className="p-4">
                            {subscriptionBoughtActive || true ? <AllProjects /> : <DashboardLock />}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        companyData: state.firestore.data.Company,
        userDataNotification: state.firestore.ordered.Notifications,
        userData: state.firebase.profile,
    }
}

export default connect(mapStateToProps)(DashboardProjects);